<template>
  <div class="form-row d-info d-frame">
    <h3>Spraw przyjemność swoim przyjaciołom, bliskim, a nawet sobie kartą Nintendo eShop!</h3>
    <p>Karta Nintendo eShop to świetny prezent dla każdego, kto lubi grać i chce się rozerwać!</p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <p>Możesz użyć karty Nintendo eShop jako szybkiej, taniej i łatwej alternatywy karty kredytowej podczas kupowania gier i innej zawartości w sklepie Nintendo eShop lub na oficjalnej stronie Nintendo.</p>
      <p>Otwórz sklep Nintendo eShop na konsoli Nintendo Switch, a zobaczysz cały świat gier gotowych do natychmiastowego zakupu i pobrania.</p>
      <p>Możesz użyć kart Nintendo eShop, aby dodać środki do swojego konta w pięciu nominałach: 70&nbsp;PLN, 120&nbsp;PLN, 250&nbsp;PLN, 370&nbsp;PLN i 500&nbsp;PLN. Zwróć uwagę na to, że sklep Nintendo eShop pokazuje ceny w walucie odpowiadającej ustawieniom regionalnym Twojej konsoli.</p>
      <h3>Kod możesz wykupić na Nintendo Switch.</h3>
      <p>Jak aktywować kod na Nintendo Switch:<br>W Nintendo eShop wybierz: REDEEM CODE („Zrealizuj kod”) lub ADD FUNDS („Dodaj środki”) i podążaj za wytycznymi na ekranie.</p>
      <h3>Uwagi prawne dotyczące kodu przedpłaconego Nintendo eShop:</h3>
      <p>Aby wykorzystać ten kod, musisz mieć dostęp do bezprzewodowego połączenia z internetem oraz zaakceptować związaną z siecią umowę użytkownika i zasady ochrony prywatności. Może być również wymagane stworzenie lub połączenie konta Nintendo Account.</p>
      <p>Ten kod:</p>
      <ul>
        <li>może być zrealizowany tylko raz, na pełną wartość, i na tę samą walutę co ta użyta do nabycia kodu.</li>
        <li>nie może być odsprzedany, wymieniony, zwrócony do punktu sprzedaży lub w żaden inny sposób zamieniony na gotówkę.</li>
        <li>nie zostanie wymieniony przez firmę Nintendo ani sprzedawcę na nowy w wypadku zgubienia, kradzieży lub wykorzystania go w inny sposób bez zgody nabywcy.</li>
      </ul>
      <p>Na wszelki wypadek, zachowaj potwierdzenie.</p>
      <p>Wydano przez Nintendo of Europe GmbH.</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoNintendo',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
